import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'

import './styles.css'

const date_format = 'DD MMM \'YY'

const DateRangeDisplay = ({ start, end, }) => (
  <small className="DateRangeDisplay">
    <span>{moment(start).format(date_format)}</span>
    <span>&nbsp;-&nbsp;</span>
    <span>{moment(end).format(date_format)}</span>
    <span>({moment(end).diff(moment(start), 'days')} days)</span>
  </small>
)

DateRangeDisplay.propTypes = {
  start: PropTypes.string.isRequired,
  end: PropTypes.string.isRequired,
}

export default DateRangeDisplay



// WEBPACK FOOTER //
// ./src/components/_molecules/DateRangeDisplay/index.js